import AbstractEffect from 'effects/AbstractEffect.js';
import {LIVE_FX} from 'constants/effect-types.js';

class LiveEffect extends AbstractEffect {
    constructor(name, effect, track) {
        super(name, track);
        this.effect = effect;
    }

    isMidiEffect() {
        return false;
    }

    dispose() {}

    getParameters() {
        return  [];
    }

    getEffectType() {
        return LIVE_FX;
    }

    getJson() {
        let json = super.getJson();
        json.effect = this.effect;
        return json;
    }
   
}

export default LiveEffect;
